import React, { useState } from 'react';
import { useStripe, useElements, CardElement } from '@stripe/react-stripe-js';

const ACCENT = '#C9A84C';

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: '#ffffff',
      fontFamily: '"Inter", -apple-system, sans-serif',
      fontSize: '16px',
      fontWeight: '500',
      '::placeholder': { color: '#555' },
      iconColor: '#888',
    },
    invalid: { color: '#ef4444', iconColor: '#ef4444' },
  },
};

export default function PaymentStep({ clientSecret, onComplete, onBack }) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);
    setError('');

    try {
      const { error: stripeError, setupIntent } = await stripe.confirmCardSetup(clientSecret, {
        payment_method: { card: elements.getElement(CardElement) },
      });

      if (stripeError) {
        setError(stripeError.message);
        return;
      }

      onComplete(setupIntent.payment_method);
    } catch (err) {
      setError('Failed to save card. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '28px' }}>
        <button onClick={onBack} className="btn btn-ghost" style={{ padding: '8px 12px' }}>← Back</button>
        <div>
          <h2 style={{ fontSize: '18px', fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.04em' }}>
            Secure Your Spot
          </h2>
          <p style={{ color: '#888', fontSize: '13px' }}>Card required to hold your appointment</p>
        </div>
      </div>

      {/* Info banner */}
      <div style={{
        background: 'rgba(201,168,76,0.04)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '8px',
        padding: '16px 20px', marginBottom: '24px', fontSize: '13px', color: '#888', lineHeight: 1.8,
      }}>
        <div style={{ color: '#ccc', fontWeight: 700, marginBottom: '6px' }}>
          🔒 Card required to secure your appointment.
        </div>
        You will not be charged until your service is completed.
        Mobile and Sunday bookings require a <strong style={{ color: ACCENT }}>50% deposit</strong> at confirmation.
        Cancellations under 3 hours: 50%. No-shows: 100%.
      </div>

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <div>
          <label className="label">Card Details</label>
          <div style={{
            background: '#141414',
            border: '1px solid #333',
            borderRadius: '8px',
            padding: '16px 18px',
          }}>
            <CardElement options={CARD_ELEMENT_OPTIONS} />
          </div>
          <p style={{ color: '#444', fontSize: '12px', marginTop: '8px' }}>
            Test card: 4242 4242 4242 4242 · Any future date · Any CVC
          </p>
        </div>

        {error && (
          <div style={{
            color: '#ef4444', background: 'rgba(239,68,68,0.08)',
            border: '1px solid rgba(239,68,68,0.25)', padding: '12px 16px',
            borderRadius: '6px', fontSize: '14px',
          }}>
            {error}
          </div>
        )}

        <button
          type="submit"
          className="btn btn-primary w-full"
          disabled={loading || !stripe}
          style={{ padding: '18px', fontSize: '14px' }}
        >
          {loading ? 'Saving Card...' : 'Save Card & Continue →'}
        </button>

        <p style={{ textAlign: 'center', color: '#444', fontSize: '12px', letterSpacing: '0.04em' }}>
          Secured by Stripe. We never store raw card details.
        </p>
      </form>
    </div>
  );
}
